module.exports = __webpack_public_path__ + "img/1.598028d7.png";